import React, { Component } from 'react';
import Formulario from './ProveedoresForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class Proveedores extends Component{
    state = {
        crear: true,
    }

    componentDidMount = () => {
        const { match, leer, listarPaises, parametrosEmpresa, getModulo } = this.props;
        const id = match.params.id;
        if (id){
            this.setState({crear: false});
            leer(id);
        }else{
            parametrosEmpresa();
        }
        listarPaises();
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        getModulo(modulo[5],modulo[4]);
    }
    
    render(){
        const { registroProveedor, modificarProveedor, loader, lectura, listaP, datos, modulo } = this.props;
        const { crear } = this.state;
        const funcionEnvio = crear ? registroProveedor : modificarProveedor;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    onSubmit = {funcionEnvio}
                    crear = {crear}
                    lectura = {lectura}
                    obtenerPaises = { listaP }
                    datos = {datos}
                    modulo = {modulo}
                />
            </LoadMask>
        );
    }
}

export default Proveedores
